import { isValidCategoricalBarData } from './categoricalBar/isValidCategoricalBarData';
import { isValidHeatGridData } from './heatGrid/isValidHeatGridData';
import { isValidRatioBarData } from './ratioBar/isValidRatioBarData';
import { isValidStatusCardGroupData } from './statusCardGroup/isValidStatusCardGroupData';
import { isValidTimeSeriesData } from './timeSeries/isValidTimeSeriesData';

// TODO: programmatically export EditableComponent.isValidData for all visualization types
export default {
  isValidTimeSeriesData,
  isValidCategoricalBarData,
  isValidRatioBarData,
  isValidStatusCardGroupData,
  isValidHeatGridData,
};
